import { Component, input } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
	selector: "stages-buttons-responsive",
	templateUrl: "./buttons-responsive.component.html",
	styleUrls: ["buttons-responsive.component.scss"],
	imports: [NgClass],
})
export class ButtonsResponsiveComponent {
	readonly removeMargin = input<boolean>(false);
}
